import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import apiService from '../services/apiservices'
import { sTAgentsTableReady} from '../redux/stores'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'


import * as Helpers from '../../../common/helpers'

//import TimePicker from 'react-time-picker'

class STAgentsCollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
            updatedTimingArr:[],
            clearIcon:null
        }
        this.dialog = null
    }

    componentWillMount() {
    }


    deleteAssignedKitchen = (row) =>{
        
        if (window.confirm("Are you sure?") === true) {
            this.props.dispatch(sTAgentsTableReady(false))
             apiService.deleteAssignedKitchen(row.agent_assignment_id)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(sTAgentsTableReady(true))
                        window.location.reload();                        
                    } else {

                        this.props.dispatch(sTAgentsTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(sTAgentsTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
        } 
    }

    
    
     actionCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        
        //let updateBtn=""
        let deleteBtn=""

        
    if(Helpers.checkPrivileges("/dashboard/storestickets/agents/add",this.props.user)){

        deleteBtn=<button
            className="action-button"
            style={{marginBottom: "1px",background: "red",color:"white"}}
            onClick={(e) => {
                e.preventDefault()
                this.deleteAssignedKitchen(row)
            }}>
            <i className="fa fa-trash" aria-hidden="true"></i> Delete
        </button>
         
         }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{deleteBtn} </div>
        </div>)
    }

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.agent_assignments}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="agent_assignment_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal'}}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="city_name"
                        className="table-header"
                        //width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        City
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="kitchen_name"
                        className="table-header"
                        //width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Assigned Kitchen
                    </TableHeaderColumn>  

                  
                    
                    <TableHeaderColumn
                        className="table-header"
                        dataFormat={this.actionCreator}
                        dataAlign='center'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Actions
                    </TableHeaderColumn>                  
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        stores: state.stores,
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(STAgentsCollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/STAgentsCollapsibleRow.js